import { Mapping } from 'api/MappingsAPI';
import { FieldType, GenericDataType } from 'modules/domains';
import { ReactNode } from 'react';
import { Props as EmptyStateProps } from 'ui/emptyState/EmptyState';

/**
 * Modals
 */
export enum ModalAction {
  NEW_EVENT_FIELD = 'newEventField',
  NEW_PURCHASE_FIELD = 'newPurchaseField',
  NEW_USER_FIELD = 'newUserField',
  EDIT_PROPERTY = 'editProperty',
  SAVE_SETTINGS = 'saveSettings',
}

export type ModalState = {
  action: ModalAction;
  payload?: {
    field?: Mapping;
    fieldProperty?: FieldProperty;
    onSave?: () => void;
    parentName?: string;
  };
};

/**
 * Search Params
 */
export interface SearchParamsContextState {
  contentSection: string;
  debouncedSearch: string;
  endDate: string;
  ingestionPolicy: string;
  journeyTriggers: string[];
  preset: string;
  resetSearchParams: (contentSection?: string) => void;
  search: string;
  setContentSection: (val: string) => void;
  setEndDate: (val: string) => void;
  setIngestionPolicy: (val: string) => void;
  setJourneyTriggers: (val: string[]) => void;
  setPreset: (val: string) => void;
  setSearch: (val: string) => void;
  setStartDate: (val: string) => void;
  setVisibility: (val: string[]) => void;
  startDate: string;
  visibility: string[];
}

export type MappingFieldValues = {
  description?: string;
  fieldName: string;
  fieldType: FieldType;
  sampleValue?: string;
};

export type EmptyStates = 'error' | 'empty' | 'noResults';

export type EmptyStateConfig = Record<EmptyStates, EmptyStateProps>;

export type FieldTableColumns = {
  /** identifier for key property */
  id: string;
  /** label displayed in the column */
  label: ReactNode;
  /** flex justify property to align text to cell */
  justify?: string;
  /** Tooltip content to be displayed with help icon */
  tooltipContent?: string;
};

/** Editable field properties */
export enum FieldProperty {
  DESCRIPTION = 'description',
  SAMPLE_VALUE = 'sampleValue',
}

export enum FieldLockState {
  On = 'on',
  Off = 'off',
}

/** Data types that are managed by a field lock setting */
export enum FieldDataType {
  CustomEvent = 'customEvent',
  /** Fields related to a custom event, not the event itself */
  CustomEventFields = 'customEventFields',
  // Purchase = 'purchase',
  User = 'user',
}

export type FieldTypeDetails = {
  dataType: GenericDataType;
  fieldType: FieldDataType;
  label: string;
  noun: string;
};

/** Settings */

/** Strings used to determine allowAutoUserFieldCreation status for RadioGroup prop */
export enum UserFieldValues {
  ALLOW_USER = 'allowUser',
  DROP_USER = 'dropUser',
}

/** Strings used to determine combination status for custom events and fields in RadioGroup */
export enum CustomEventValues {
  ALLOW_EVENT_AND_FIELDS = 'allowEventAndFields',
  DROP_EVENTS_ALLOW_FIELDS = 'dropEventsAllowFields',
  DROP_BOTH_EVENTS_AND_FIELDS = 'dropBothEventsAndFields',
}
